import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import i18n from "../i18n";

export default function Reference() {
  const [langTick, setLangTick] = useState(0);

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  // eslint-disable-next-line no-unused-vars
  const _ = langTick;

  const reference = [
    {
      title: i18n.t("references.items.porr.title"),
      description: i18n.t("references.items.porr.description"),
      image: `${process.env.PUBLIC_URL}/images/porr.jpg`,
      link: "/porr",
    },
    {
      title: i18n.t("references.items.loweraustria.title"),
      description: i18n.t("references.items.loweraustria.description"),
      image: `${process.env.PUBLIC_URL}/images/lower_austria.jpg`,
      link: "/loweraustria",
    },
    {
      title: i18n.t("references.items.pva.title"),
      description: i18n.t("references.items.pva.description"),
      image: `${process.env.PUBLIC_URL}/images/pension.jpg`,
      link: "/pva",
    },
    {
      title: i18n.t("references.items.brz.title"),
      description: i18n.t("references.items.brz.description"),
      image: `${process.env.PUBLIC_URL}/images/brz.jpg`,
      link: "/brz",
    },
  ];

  return (
    <section className="py-12 px-6 lg:px-0">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold mb-4">{i18n.t("references.title")}</h2>

        <p className="text-gray-600 mb-10 max-w-3xl">
          {i18n.t("references.subtitle")}
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="lg:col-span-1">
            <div className="flex flex-col sm:flex-col lg:block bg-white rounded-xl shadow p-4 h-full">
              <div className="w-full aspect-[3/2] flex-shrink-0">
                <img
                  src={reference[0].image}
                  alt=""
                  aria-hidden="true"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>

              <div className="mt-4">
                <h3 className="font-semibold text-xl">{reference[0].title}</h3>
                <p className="text-gray-600 text-base">
                  {reference[0].description}{" "}
                  <Link to={reference[0].link} className="text-blue-600">
                    {i18n.t("references.viewFullBlog")}
                  </Link>
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-1 grid gap-4 h-full">
            {reference.slice(1).map((ref, idx) => (
              <div key={idx} className="h-full">
                <div className="flex flex-col sm:flex-row items-start gap-4 bg-white rounded-xl shadow p-4 h-full">
                  <div className="w-full sm:w-48 aspect-[3/2] flex-shrink-0">
                    <img
                      src={ref.image}
                      alt=""
                      aria-hidden="true"
                      className="w-full h-full object-cover rounded-lg"
                    />
                  </div>

                  <div>
                    <h4 className="font-semibold text-base">{ref.title}</h4>
                    <p className="text-gray-600 text-base">
                      {ref.description}{" "}
                      <Link to={ref.link} className="text-blue-600">
                        {i18n.t("references.viewFullBlog")}
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}


















